import axios from 'axios'

export default function getGeoJSON(url) {
  let params = {}

  return axios.get(url, {
    params: params,
  })
}



// WEBPACK FOOTER //
// ./F:/Development/geoviewer2/src/services/getGeoJSON.js